module.exports = __webpack_public_path__ + "img/epsLogo.c5016b7b.png";